import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export type PayResultSearch = { payment?: string }

export const payResultRoute = createRoute({
  path: 'pay/result',
  getParentRoute: () => rootRoute,
  validateSearch: (search: Record<string, unknown>): PayResultSearch =>
    typeof search.payment === 'string' && search.payment ? { payment: search.payment } : {},
  component: lazyRouteComponent(() => import('../features/topup/result-page'), 'PayResultPage'),
  errorComponent: RouteError,
})
